import { gql } from '@apollo/client';
import { ID_NAME_FIELDS, PROPERTY_MAIN_FIELDS } from 'graphql/common/fragments';

export const AVAILABILITY_DATA = gql`
  fragment availabilityData on Availability {
    id
    property {
      ${PROPERTY_MAIN_FIELDS}
      market {
        ${ID_NAME_FIELDS}
      }
      propertyType {
        ${ID_NAME_FIELDS}
      }
      submarket {
        ${ID_NAME_FIELDS}
      }
      micromarket {
        ${ID_NAME_FIELDS}
      }
      propertyClass {
        ${ID_NAME_FIELDS}
      }
      status {
        ${ID_NAME_FIELDS}
      }
    }
    spaceUse {
      ${ID_NAME_FIELDS}
    }
    landlordBrokerCompany {
      ${ID_NAME_FIELDS}
    }
    askingRent
    askingRentMin
    askingRentMax
    timeMeasurement
    askingRentType
    askingRentTypeId
    suite
    leaseTypeId
    fullFloor
    floor
    availableSpace
    availableSpaceMin
    availableSpaceMax
    availableSpaceMt
    availableSpaceMinMt
    availableSpaceMaxMt
    floorContiguousSpace
    floorContiguousSpaceMt
    buildingContiguousSpace
    buildingContiguousSpaceMt
    landlordBrokerContacts
    propertySetId
    comments
    status
    occupancy
    occupancyDate
    occupancyStatusType {
      ${ID_NAME_FIELDS}
    }
    term
    fileId
    freeRentType
    freeRentTypeId
    freeRentMonths
    tenantImprovementAllowance
    officeSf
    officeSm
    typicalClearHeightMin
    typicalClearHeightMax
    typicalClearHeightMinMt
    typicalClearHeightMaxMt
    loadingDocks
    driveInDoors
    taxAndOpex
  }
`;
